"use client";

// Централизованная отправка целей (goals) в Яндекс.Метрику.
//
// Автопилот — один домен и один счётчик на все города (в отличие от
// Солнышка с пер-городскими счётчиками). Чтобы маркетолог всё же видел
// конверсии в разрезе городов, к каждой цели добавляем параметр city
// (slug текущего города). Город выставляется через setTrackCity(), когда
// он становится известен (поиск, карточка, бронь); можно и явно передать
// {city} в params.
//
// Счётчик и флаг включения приходят из настроек в layout.tsx и лежат на
// window.__apMetrika. Идентификаторы целей — контракт с каталогом в
// админке (admin/src/data/metrikaEvents.ts): добавляя track(...), внесите
// строку и туда.

type MetrikaCfg = { counter: number; enabled: boolean };

declare global {
  interface Window {
    __apMetrika?: MetrikaCfg;
    __apCity?: string;
    ym?: (...args: unknown[]) => void;
  }
}

function cfg(): MetrikaCfg {
  if (typeof window === "undefined") return { counter: 0, enabled: false };
  return window.__apMetrika || { counter: 0, enabled: false };
}

// setTrackCity — запомнить текущий город (slug), чтобы цели уходили с
// разбивкой по городу без прокидывания city в каждый вызов.
export function setTrackCity(slug?: string): void {
  if (typeof window !== "undefined" && slug) window.__apCity = slug;
}

// track — отправить цель. Город подставляется автоматически из
// window.__apCity, если не передан явно в params.city.
export function track(goal: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const { counter, enabled } = cfg();
  if (!enabled || !counter) return;
  const ym = window.ym;
  if (typeof ym !== "function") return;
  const hasCity = params && Object.prototype.hasOwnProperty.call(params, "city");
  const city = hasCity ? undefined : window.__apCity;
  const merged = { ...(params || {}), ...(city ? { city } : {}) };
  const rest = Object.keys(merged).length ? [merged] : [];
  try {
    ym(counter, "reachGoal", goal, ...rest);
  } catch {
    /* Метрика не загрузилась — цель теряется, UI не роняем */
  }
}
